/** id записи variables-* API (не имя, не id детали / paced-detail). */
export const resolveCompositionVariableRecordId = (row) => {
    if (row == null || typeof row !== "object") {
        return null;
    }
    const raw = row.id ?? row.variableId ?? row.compositionVariableId;
    if (raw == null || raw === "") {
        return null;
    }
    if (Number(raw) === 0) {
        return null;
    }
    return raw;
};

/** Строки для VariablesTable: массив или map values с бэка. */
export const normalizeVariablesTableRows = (mapOrList) => {
    if (!mapOrList) {
        return [];
    }
    const list = Array.isArray(mapOrList)
        ? mapOrList.filter(Boolean)
        : typeof mapOrList === "object"
            ? Object.values(mapOrList).filter(Boolean)
            : [];
    return list.map((row) => {
        const recordId = resolveCompositionVariableRecordId(row);
        return recordId != null ? {...row, id: recordId} : row;
    });
};
